import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
		userInfo:uni.getStorageSync('userInfo')||
		{
			openId: '',
			memberId: '',
			nickname: '',
			headimgurl: '',
			subscribe: '',
			sex: '',
		},
		proxyUrl: 'https://www.lishicloud.com'
	},
    mutations: {
		changeUserInfo(state,userInfo){
			state.userInfo=userInfo
		}
	},
    actions: {}
})

export default store